exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".border-deep {\n  border-top: 1px solid #e0e0e0 !important;\n}\n.bg-deep {\n  background-color: #e0e0e0 !important;\n}\n", ""]);

